export default {
  dbOption: {
    Title: "Tùy chọn",
    GeneralTabTitle: "Tùy chọn chung",
    EmailTabTitle: "Tùy chọn email",
    Apply: "Áp dụng",
  },

  GeneralTab: {},
  MailTab: {},
};
